(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["armas-collection-tabs"] && !Shopify.designMode) return;
  try {
    
function initArmasTabs(root){root.querySelectorAll('[data-collection-tabs]').forEach(group=>{if(group.dataset.initialized)return;group.dataset.initialized='true';const tabs=[...group.querySelectorAll('[role=tab]')];function activate(tab){tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;const panel=document.getElementById(t.getAttribute('aria-controls'));panel.hidden=!active;if(active)panel.querySelector('[data-product-showcase]')?.dispatchEvent(new CustomEvent('armas:showcase:refresh'));});}tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(tab));tab.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i-1+tabs.length)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();activate(tabs[n]);tabs[n].focus();});});});}initArmasTabs(document);document.addEventListener('shopify:section:load',e=>initArmasTabs(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["armas-header"]) return;
  try {
    
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 1101px) and (hover: hover)');
    const closeAll = (except = null) => {
      document.querySelectorAll('.nav-dropdown[open]').forEach((menu) => {
        if (menu !== except) menu.removeAttribute('open');
      });
    };
    const initDesktopMenus = (scope = document) => {
      const menus = [];
      if (scope.matches?.('.nav-dropdown')) menus.push(scope);
      scope.querySelectorAll?.('.nav-dropdown').forEach((menu) => menus.push(menu));
      menus.forEach((menu) => {
        if (menu.dataset.desktopMenuReady === 'true') return;
        menu.dataset.desktopMenuReady = 'true';
        let closeTimer;
        const open = () => {
          if (!desktopQuery.matches) return;
          window.clearTimeout(closeTimer);
          closeAll(menu);
          menu.setAttribute('open', '');
        };
        const close = () => {
          window.clearTimeout(closeTimer);
          closeTimer = window.setTimeout(() => menu.removeAttribute('open'), 140);
        };
        menu.addEventListener('pointerenter', open);
        menu.addEventListener('pointerleave', close);
        menu.addEventListener('focusin', open);
        menu.addEventListener('focusout', (event) => {
          if (!menu.contains(event.relatedTarget)) close();
        });
        menu.addEventListener('toggle', () => {
          if (menu.open) closeAll(menu);
        });
      });
    };
    document.addEventListener('pointerdown', (event) => {
      if (!event.target.closest('.nav-dropdown')) closeAll();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      closeAll();
      document.activeElement?.closest('.nav-dropdown')?.querySelector('summary')?.focus();
    });
    desktopQuery.addEventListener?.('change', () => closeAll());
    initDesktopMenus(document);
    document.addEventListener('shopify:section:load', (event) => initDesktopMenus(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["armas-hero"] && !Shopify.designMode) return;
  try {
    
  function initArmasHeroSliders(scope){scope.querySelectorAll('[data-hero-slider]').forEach(slider=>{if(slider.dataset.initialized)return;slider.dataset.initialized='true';const slides=[...slider.querySelectorAll('[data-hero-slide]')];const dots=[...slider.querySelectorAll('[data-hero-dot]')];const delay=Math.max(3000,Number(slider.dataset.delay)||5000);const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;const videosEnabled=slider.dataset.videoAutoplay==='true';let current=Math.max(0,slides.findIndex(slide=>slide.dataset.active==='true'));let timer=null;let pointerStart=null;let videoReady=false;slider.querySelectorAll('video img:not([alt])').forEach(image=>image.alt='');const hydrate=slide=>{slide.querySelectorAll('[data-srcset]').forEach(node=>{node.srcset=node.dataset.srcset;node.removeAttribute('data-srcset');});slide.querySelectorAll('[data-src]').forEach(node=>{node.src=node.dataset.src;node.removeAttribute('data-src');});};const videoState=()=>slides.forEach((slide,index)=>slide.querySelectorAll('video').forEach(video=>{if(index===current&&!reduced&&videoReady){video.play().then(()=>video.classList.add('is-playing')).catch(()=>{});}else{video.pause();video.classList.remove('is-playing');}}));const show=index=>{const next=(index+slides.length)%slides.length;hydrate(slides[next]);slides.forEach((slide,slideIndex)=>{const active=slideIndex===next;slide.dataset.active=String(active);slide.setAttribute('aria-hidden',String(!active));if(active)slide.removeAttribute('inert');else slide.setAttribute('inert','');});dots.forEach((dot,dotIndex)=>dot.setAttribute('aria-pressed',String(dotIndex===next)));current=next;videoState();};const stop=()=>{if(timer)window.clearInterval(timer);timer=null;};const start=()=>{stop();if(slides.length>1&&slider.dataset.autoplay==='true'&&!reduced&&!document.hidden)timer=window.setInterval(()=>show(current+1),delay);};const interact=index=>{show(index);start();};slider.querySelector('[data-hero-previous]')?.addEventListener('click',()=>interact(current-1));slider.querySelector('[data-hero-next]')?.addEventListener('click',()=>interact(current+1));dots.forEach(dot=>dot.addEventListener('click',()=>interact(Number(dot.dataset.heroDot))));slider.addEventListener('keydown',event=>{if(event.key==='ArrowLeft')interact(current-1);if(event.key==='ArrowRight')interact(current+1);});slider.addEventListener('pointerenter',stop);slider.addEventListener('pointerleave',start);slider.addEventListener('focusin',stop);slider.addEventListener('focusout',event=>{if(!slider.contains(event.relatedTarget))start();});slider.querySelector('[data-hero-viewport]')?.addEventListener('pointerdown',event=>{pointerStart=event.clientX;});slider.querySelector('[data-hero-viewport]')?.addEventListener('pointerup',event=>{if(pointerStart==null)return;const distance=event.clientX-pointerStart;pointerStart=null;if(Math.abs(distance)>45)interact(current+(distance<0?1:-1));});document.addEventListener('visibilitychange',()=>document.hidden?stop():start());slider.addEventListener('shopify:block:select',event=>{const selected=slides.indexOf(event.target.closest('[data-hero-slide]'));if(selected>=0)show(selected);stop();});if(videosEnabled){const enableVideo=()=>{videoReady=true;videoState();};if(document.readyState==='complete')window.setTimeout(enableVideo,4000);else window.addEventListener('load',()=>window.setTimeout(enableVideo,4000),{once:true});}start();});}initArmasHeroSliders(document);document.addEventListener('shopify:section:load',event=>initArmasHeroSliders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["armas-media-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initMediaStories = (scope = document) => {
      const sections = [];
      if (scope.matches?.('[data-media-story]')) sections.push(scope);
      scope.querySelectorAll?.('[data-media-story]').forEach((section) => sections.push(section));
      sections.forEach((section) => {
        if (section.dataset.mediaStoryReady === 'true') return;
        section.dataset.mediaStoryReady = 'true';
        const video = section.querySelector('.media-story__video[autoplay]');
        if (!video) return;
        video.muted = true;
        video.playsInline = true;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.pause();
          return;
        }
        const play = () => video.play().catch(() => {});
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) play();
            else video.pause();
          }, {rootMargin: '180px 0px', threshold: .15});
          observer.observe(section);
        } else play();
      });
    };
    initMediaStories(document);
    document.addEventListener('shopify:section:load', (event) => initMediaStories(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["armas-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initArmasRecommendations = (scope = document) => {
      const sections = [];
      if (scope.matches?.('[data-recommendations]')) sections.push(scope);
      scope.querySelectorAll?.('[data-recommendations]').forEach((section) => sections.push(section));
      sections.forEach((section) => {
      if (section.dataset.loaded === 'true') return;
      const load = async () => {
        section.dataset.loaded = 'true';
        try {
          const response = await fetch(section.dataset.url, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
          if (!response.ok) throw new Error('Product recommendations request failed');
          const html = await response.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const incoming = parsed.querySelector('[data-recommendations]');
          incoming?.querySelectorAll('[data-reveal]').forEach((node) => node.classList.add('is-visible'));
          if (incoming?.innerHTML.trim()) {
            section.innerHTML = incoming.innerHTML;
            section.dispatchEvent(new CustomEvent('shopify:section:load', {bubbles: true}));
          }
          else section.hidden = true;
        } catch (error) {
          section.hidden = true;
        } finally {
          section.setAttribute('aria-busy', 'false');
        }
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          load();
        }, {rootMargin: '0px 0px 300px 0px'});
        observer.observe(section);
      } else load();
      });
    };
    initArmasRecommendations(document);
    document.addEventListener('shopify:section:load', (event) => initArmasRecommendations(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
